import React, {FC} from 'react'
import styled from 'styled-components'
import { Form } from 'semantic-ui-react'

//@ts-ignore
import FormField from 'shared/newFormElements'
import SearchGrid from '../SearchGrid'

import containerForm from './containerForm'
import { LoanDetailsBase } from 'src/features/LoanDetails/types.LoanDetails'

const Wrapper = styled.div`
  flex: 1;

  .ui.form {
    display: flex;
    flex-direction: column;
    height: 100%;

    .comment-field {
      flex: 0;

      div,
      textarea {
        height: 100%;
      }
    }
  }
`

const AddForm: FC<{
  name: string,
  ID: string,
  hash: string, 
  base: LoanDetailsBase
}> = () => (
  <Wrapper>
    <Form>
      {/* @ts-ignore */}
      <SearchGrid />
      <p className="u-marginTop-10 u-marginBottom-5">კომენტარი:</p>
      <div className="comment-field">
        <FormField name="Comment" type="textarea" />
      </div>
    </Form>
  </Wrapper>
)
//@ts-ignore
export default containerForm(AddForm)
